let visibleMobileConsole = false;
const { DEV, MODE } = import.meta.env;

export const isProduction = MODE === 'production';
export const isStaging = MODE === 'staging' && !DEV;
export const isDEV = () => DEV || location.href.indexOf('gtm') > -1;

export const showConsole = (productionAllowed = false) => {
  if (visibleMobileConsole || !(isStaging || productionAllowed)) return;
  const script = document.createElement('script');

  script.src =
    'https://cdnjs.cloudflare.com/ajax/libs/eruda/3.4.1/eruda.min.js';

  script.onload = () => (window as Application).eruda?.init();
  document.head.append(script);
  visibleMobileConsole = true;
};
